/**
 * Global settings
 */

const simuPP_appmobile_URL = "simulation/pret-personnel.html",
    // same domain as the hub itself, matching build.config.js's htmlFiles/outputDir
    simuPP_desktop_URL = "simulation/pret-personnel.html";


const simuCR_appmobile_URL = "simulation/tresorerie.html",
    // same domain as the hub itself, matching build.config.js's htmlFiles/outputDir
    simuCR_desktop_URL =  "simulation/tresorerie.html";

let parameters = {};

/**
 * Credit data
 */
var discount_code = null,
    current_actioncom_discount = null;
/**
 * Credit preset
 */

/* API */
var discounts_special_url = "/dam/axa/desktop/banque-credits/banque-simulateur-credit-conso/actioncomdiscounts_special.json";

/* Data get from server */
var actioncomdiscounts_special = null;

/**
 * getDiscountsSpecial
 */
function getDiscountsSpecial() {
  let requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  fetch(discounts_special_url, requestOptions)
    .then(response => response.text())
    .then((result) => {
        actioncomdiscounts_special = JSON.parse(result);
        presetByUrl();
    })
    .catch(error => console.log('error', error));
}

/**
 * presetByUrl
 */
function presetByUrl() {
  /* Parameters (get) */
  let UrlParser = new GetURLParams(window.location.search);
  parameters = UrlParser.urlParams;

  if (parameters["promo"]) {
     let codePromo = parameters["promo"].toUpperCase();
     discount_code = codePromo;
     if (actioncomdiscounts_special) {
        current_actioncom_discount = actioncomdiscounts_special[codePromo];
        renderDiscount();
     }
  //   getDiscount(codePromo);
  }

  console.log("ENV", ENV);
}

/**
 * renderDiscountIntro
 * Promo "introduction" rule: non-empty string replaces the intro,
 * empty/whitespace-only string hides it, null/absent keeps the default intro.
 * @param {*} intro
 */
function renderDiscountIntro(intro) {
  if (typeof intro !== "string" || !$simuIntro) {
    return;
  }
  if (intro.trim() === "") {
    $simuIntro.classList.add("hidden");
  } else {
    $simuIntro.innerHTML = intro;
  }
}

/**
 * renderDiscount
 * Display discount infos (header, additional fields, legal mentions, etc.)
 */
function renderDiscount() {
  let className = ($discountDescription.className).replace("hidden", "").trim();

  if (discount_code) { /* actioncomdiscount */
     if (current_actioncom_discount) {
        // Layout & fields
        // if (current_actioncom_discount.isAppliable && current_actioncom_discount.isValid) {
           $simuHUB.setAttribute("class", current_actioncom_discount.theme);
        // }
        // Header + intro
        // if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
           $discountLabel.innerHTML = current_actioncom_discount.label ?
              current_actioncom_discount.label : "";
           $discountCatchphrase.innerHTML = current_actioncom_discount.catchphrase ?
              current_actioncom_discount.catchphrase : "";
           renderDiscountIntro(current_actioncom_discount.introduction);
        // }
        // Description
        // Optional per-promo flag: hide the "En cours : ..." line (stays hidden, nothing injected)
        if (current_actioncom_discount.hideCurrentOfferInMentions !== true) {
           $discountDescription.setAttribute("class", className);
           $discountDescription.innerHTML =
               "<p><span class='semibold'>En cours&nbsp;:</span> " + current_actioncom_discount.labelShort + "</p>";
        }
        // Mentions
        // if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
           $discountMentions.innerHTML = current_actioncom_discount.mentions;
           $discountMentions.classList.remove("hidden");
        // }

        /* hide global discount mentions */
        if (current_actioncom_discount.mentions) {
           $discountMentionsGlobal.classList.add("hidden");
        }
     } else {
        $discountDescription.innerHTML = "<p><strong>Il n'existe pas de taux promotionnel lié à ce code promo.</strong></p>";
     }
  }
}
/**
 * Utils
 */

var $simuHUB = document.getElementById("simu-credit-conso-hub"),
    $discountLabel = document.getElementById("discount-label"),
    $simuIntro = document.getElementById("simu-intro"),
    $discountCatchphrase = document.getElementById("discount-catchphrase"),
    $discountDescription = document.getElementById("discount-description"),
    $discountMentionsGlobal = document.getElementById("discount-mentions-global"),
    $discountMentions = document.getElementById("discount-mentions");
// Btn
var $creditTypePP_btn = document.getElementById("credit-type-pp"),
    $creditTypeCR_btn = document.getElementById("credit-type-cr");


/**
 * GetURLParams
 */
class GetURLParams {
  constructor (urlSearch) {
    this.urlSearch = urlSearch
    this.urlParams = this.parseUrlSearch(this.urlSearch)
  }

  parseUrlSearch (query) {
    if (!query) {
      return {};
    }

    let vars = query.split('&');
    let query_string = {};

    for (var i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      pair[0] = pair[0].replace('?', '');
      // If first entry with this name
      if (typeof query_string[pair[0]] === 'undefined') {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
        // If second entry with this name
      } else if (typeof query_string[pair[0]] === 'string') {
        let arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
        query_string[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }

    return query_string;
  }
}

(function () {
   /* Handle promo */
   getDiscountsSpecial();

   /* Handle buttons */
   // Handle >= 5 000 button
   $creditTypePP_btn.onclick = function(e) {
      window.location.href =
         (ENV === "DESKTOP" ? simuPP_desktop_URL : simuPP_appmobile_URL)
            + window.location.search;
   }

   // Handle < 5 000 button
   $creditTypeCR_btn.onclick = function(e) {
      window.location.href =
         (ENV === "DESKTOP" ? simuCR_desktop_URL : simuCR_appmobile_URL)
            + window.location.search;
   }

   // Mémo Le Printemps du Crédit :
   // PDC2024 pour les non détenteurs CR
   // PDCCR2024 pour les détenteurs CR

   // Pour L'Instant Crédit (et campagnes suivantes) :
   // Même offre promo PP et CR pour tous les clients ciblés (détenteurs CR et non détenteurs CR)
   // Pas de distinction entre détenteurs CR et non détenteurs CR
   // Hormis pour le routage de la demande via la messagerie sécurisée
   // >> garder les codes promo distincts pour permettre le bon routage
   // >> ajouter le code promo "non détenteur CR" dans le .json afin d'appliquer la promo CR même pour les non détenteurs
   // Exemple avec Le Printemps du Crédit, le .json devrait contenir :
   //    >> PDC2024 ; PDCCR2024, PDC2024_CR ; PDCCR2024_CR

   // Test avec ?promo=PDCCR2024&utm_source=autopromotion&utm_medium=email&utm_campaign=fid_pp_lpc&utm_content=cr_directs_lpc24_lancement
   // >> application habillage, wording et mentions légales
   // >> transmission de tous les paramètres

})();

(function () {

  /* Accordion FAQ */
  function initFaq(toggle) {
   const button = document.createElement('button');
   button.innerText = '-';
   toggle.append(button);
  }
  function setFaqExpanded(toggle, expanded) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      const button = toggle.querySelector('button');
      if (button) {
         button.innerHTML = expanded ? '<span class="desktop">−</span><span class="mobile"><i class="axa-icons axa-icons-arrow-up"></i></span>' : '<span class="desktop">+</span><span class="mobile"><i class="axa-icons axa-icons-arrow-down"></i></span>';
      }
      var questionBlock = toggle.closest('.faq-item');
      if (questionBlock) {
         questionBlock.classList.toggle('is-collapsed', !expanded);
      }
   }

   const faqToggles = document.querySelectorAll('#faq .faq-item__question');
   for (var i = 0; i < faqToggles.length; i++) {
      (function (toggle) {
         initFaq(toggle);
         setFaqExpanded(toggle, false);
         toggle.addEventListener('click', function () {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            setFaqExpanded(toggle, !expanded);
         });
      })(faqToggles[i]);
   }

})();

